import DetailContentRow from './DetailContentRow'

export default DetailContentRow
